export enum AnalyticsEvents {
  FIRST_LAUNCH = 'desktopapp.first_launch',
  CLICK_LOGIN = 'desktopapp.click_login',
  CLICK_LOGOUT = 'desktopapp.click_logout',
  CLICK_MINIMIZE = 'desktopapp.click_minimize',
  CLICK_CLOSE = 'desktopapp.click_close',
  CLONE_CLICK_GO = 'desktopapp.clone.click_go',
  OVERLAY_CLICK_GO = 'desktopapp.overlay.click_go',
  SEND_APPLICATION_LOGS = 'desktopapp.send_application_logs',
  CLICK_UPDATE_COMPLETED = 'desktopapp.clicked_update_completed',
  CLICK_DOWNLOAD_UPDATE = 'desktopapp.clicked_download_update',
  RESTART_APP = 'desktopapp.restart_app',
  CLOSE_SPEAKER_PANEL = 'presentation.click_speakerpanel_deactivate',
  SPEAKER_PANEL_SWITCH_DEMO = 'presentation.toggle_speakerpanel',
  PRESENTATION_TAB_LOAD = 'presentation.tab_load',
  DEEPLINK = 'desktopapp.login.desktop',
  CLONE_OPEN_IN_PREVIEW = 'clone.open_in_preview',
  PRESENTATION_BROWSER_MODE_URL_VISIT = 'desktopapp.presentation.browser_mode.url_visit',
  CLICK_CREATE_GLOBAL_TAB = 'desktopapp.click_create_global_tab',
  CLICK_CLOSE_GLOBAL_TAB = 'desktopapp.click_close_global_tab',
  CLICK_ADD_PERSONA = 'desktopapp.click_add_persona',
  CLICK_SWITCH_PERSONA = 'desktopapp.click_switch_persona',
  SETTINGS_TAB_CACHING_CHANGE = 'desktopapp.settings.change_tab_caching',
  SETTINGS_PERSISTENT_CACHING_ENABLED = 'desktopapp.settings.persistent_caching_enabled',
  SETTINGS_MOUSE_ANIMATION_SIZE_CHANGE = 'desktopapp.settings.mouse_animation_size_change',
  SETTINGS_MOUSE_ANIMATION_COLOR_CHANGE = 'desktopapp.settings.mouse_animation_color_change',
  SETTINGS_MOUSE_ANIMATION_SPEED_CHANGE = 'desktopapp.settings.mouse_animation_speed_change',
  SETTINGS_MOUSE_ANIMATION_TOGGLE_CHANGE = 'desktopapp.settings.mouse_animation_toggle_change',
  SETTINGS_BROWSER_HOME_PAGE_CHANGE = 'desktopapp.settings.browser_home_page_change',
  SETTINGS_PRESENTATION_DISPLAY_DOMAIN_MODE_CHANGE = 'desktopapp.settings.presentation_display_domain_mode_change',
  SETTINGS_PRESENTATION_DISPLAY_SPEAKER_PANEL_VISIBILITY_CHANGE = 'desktopapp.settings.presentation_display_speaker_panel_visibility_change',
  GO_TO_ASSET_WITH_LINK = 'desktopapp.go_to_asset_with_link',
  TIME_TO_LOAD = 'desktopapp.time_to_load',
  APP_CRASH = 'desktopapp.app_crash',
}
